import { StyledSelect } from '../ui';

const StyledSelectProductCategory = StyledSelect.extend`
  border-radius: 0;
  border-top: 0;
  border-right: 0;
  border-left: 0;
  appearance: none;
`;

export default StyledSelectProductCategory;


// WEBPACK FOOTER //
// ./src/modules/common/components/form/ui/StyledSelectProductCategory.js